"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _hooks = require("@datepicker-react/hooks");
var _dayjs = _interopRequireDefault(require("dayjs"));
var _Day = _interopRequireDefault(require("../Day"));
var _index = _interopRequireDefault(require("./index.style"));
function Month(_ref) {
  let {
    year,
    month,
    firstDayOfWeek,
    monthRef
  } = _ref;
  const classes = (0, _index.default)();
  const {
    days,
    weekdayLabels,
    monthLabel
  } = (0, _hooks.useMonth)({
    year,
    month,
    firstDayOfWeek,
    monthLabelFormat: date => (0, _dayjs.default)(date).format('MMMM'),
    dayLabelFormat: date => (0, _dayjs.default)(date).format('D')
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: monthRef,
    className: classes.monthWrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.monthLabel
  }, monthLabel, " ", year), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.monthWeekdayLabels
  }, weekdayLabels.map(dayLabel => /*#__PURE__*/_react.default.createElement("div", {
    className: classes.monthDaysLabel,
    key: dayLabel
  }, dayLabel.charAt(0)))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.monthDays
  }, days.map((day, index) => {
    if (typeof day === 'object') {
      return /*#__PURE__*/_react.default.createElement(_Day.default, {
        key: day.date.toString(),
        day: day.dayLabel,
        date: day.date
      });
    }
    // eslint-disable-next-line react/no-array-index-key
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index
    });
  })));
}
var _default = exports.default = Month;